export const serviceLocalStorage = {
  setLocalStorage: (data = null) => {
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    localStorage.setItem('token_lifetime', data.token_lifetime);
    localStorage.setItem('user_id', data.user_id);
    localStorage.setItem('user_role', data.role.id);
  },
  clearLocalStorage: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_lifetime');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_role');
  },
  getAccessToken: () => localStorage.getItem('access_token'),
  getRefreshToken: () => localStorage.getItem('refresh_token'),
  getUserID: () => localStorage.getItem('user_id'),
  getUserRoleID: () => localStorage.getItem('user_role'),
};
